var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Celo_Logotype",
    width: 5306,
    height: 1575,
    "data-name": "Celo Logotype",
    viewBox: "0 0 5306 1575",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6579 0 0 1.6579 -623 -414.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Type",
    className: "cls-1",
    d: "m2817 1089 86-27v-712l-86 27zm-992-432c54 0 104 24 136 64l35-81c-46-44-107-65-171-65-148 0-250 117-249 246 1 140 111 254 249 254 70 0 123-21 163-50v-99c-42 42-103 67-156 67-80 0-170-65-170-172 0-99 78-164 163-164zm572-82c-148 0-234 117-234 246 0 140 111 254 249 254 70 0 123-21 163-50v-99c-42 42-103 67-156 67-71 0-149-44-165-137h377v-33c0-138-91-248-234-248zm929 0c-138 0-250 112-250 250s112 250 250 250 250-112 250-250-112-250-250-250zm-928 82c67 0 138 42 144 123h-288c6-81 77-123 144-123zm928 336a168 168 0 1 1 168-168 167.72 167.72 0 0 1-168 168z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bottom_Ring",
    className: "cls-1",
    d: "m751 1105c154.64 0 280-125.36 280-280s-125.36-280-280-280-280 125.36-280 280 125.36 280 280 280zm0 95c-207.1 0-375-167.9-375-375s167.9-375 375-375 375 167.9 375 375-167.9 375-375 375z",
    "data-name": "Bottom Ring"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_Ring",
    className: "cls-1",
    d: "m951 905c154.64 0 280-125.36 280-280s-125.36-280-280-280-280 125.36-280 280 125.36 280 280 280zm0 95c-207.1 0-375-167.9-375-375s167.9-375 375-375 375 167.9 375 375-167.9 375-375 375z",
    "data-name": "Top Ring"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelo);
export default __webpack_public_path__ + "static/media/celo.0aff6980008a8856a7b9710ff2b63703.svg";
export { ForwardRef as ReactComponent };